import { render, staticRenderFns } from "./ImpotSur.vue?vue&type=template&id=3fa0d7da"
import script from "./ImpotSur.vue?vue&type=script&lang=js"
export * from "./ImpotSur.vue?vue&type=script&lang=js"
import style0 from "./ImpotSur.vue?vue&type=style&index=0&id=3fa0d7da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports